import { removeDiacritics } from '../../utils/remove_diacritics';
import Fuse from 'fuse.js/dist/fuse.esm';

(function () {
  let $; let AbstractChosen; let Chosen; let SelectParser; let fuzzysearch; let resultsAreInitialized = false;
  let __extends = function (child, parent) {for (let key in parent) {if (__hasProp.call(parent, key)) child[key] = parent[key];} function ctor() {this.constructor = child;} ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child;};
  let __hasProp = {}.hasOwnProperty;

  fuzzysearch = function (needle, haystack) {
    if (!needle.length) return true;

    needle = removeDiacritics(needle.toLowerCase());
    haystack = removeDiacritics(haystack.toLowerCase());
    let opt = {
      threshold:          0.2,
      tokenize:           true,
      tokenSeparator:     /\s+/g,
      matchAllTokens:     true,
      location:           0,
      distance:           140,
      maxPatternLength:   32,
      minMatchCharLength: 1,
      keys:               ['title']
    };
    let fuse = new Fuse([{ title: haystack }], opt);
    let o = fuse.search(needle);
    let bln = !!o.length;

    return bln;
  };

  SelectParser = (function () {
    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }

    SelectParser.prototype.add_node = function (child) {
      if (child.nodeName.toUpperCase() === 'OPTGROUP') {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };

    SelectParser.prototype.add_group = function (group) {
      let group_position; let option; let _i; let _len; let _ref; let _results;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group:       true,
        label:       this.escapeExpression(group.label),
        title:       group.title ? group.title : void 0,
        children:    0,
        disabled:    group.disabled,
        classes:     group.className
      });
      _ref = group.childNodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        _results.push(this.add_option(option, group_position, group.disabled));
      }
      return _results;
    };

    SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
      if (option.nodeName.toUpperCase() === 'OPTION') {
        if (option.text !== '') {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }
          this.parsed.push({
            array_index:       this.parsed.length,
            options_index:     this.options_index,
            value:             option.value,
            text:              option.text,
            html:              option.innerHTML,
            allow_children:    option.getAttribute('data-allow-children'),
            max_children_age:  option.getAttribute('data-max-childre-age'),
            min_children_age:  option.getAttribute('data-min-childre-age'),
            group_array_index: option.getAttribute('group_array_index'),
            id:                option.getAttribute('value'),
            url:               option.getAttribute('data-url'),
            title:             option.title ? option.title : void 0,
            selected:          option.selected,
            disabled:          group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            group_label:       group_position != null ? this.parsed[group_position].label : null,
            classes:           option.className,
            style:             option.style.cssText,
            check_in:          option.getAttribute('data-check-in'),
            check_out:         option.getAttribute('data-check-out'),
            translations:      option.getAttribute('data-translations') ? option.getAttribute('data-translations').split(',') : void 0
          });
        } else {
          this.parsed.push({
            array_index:   this.parsed.length,
            options_index: this.options_index,
            empty:         true
          });
        }
        return this.options_index += 1;
      }
    };

    SelectParser.prototype.escapeExpression = function (text) {
      let map; let unsafe_chars;
      if ((text == null) || text === false) {
        return '';
      }
      if (!/[\&\<\>\"\'\`]/.test(text)) {
        return text;
      }
      map = {
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '`': '&#x60;'
      };
      unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
      return text.replace(unsafe_chars, function (chr) {
        return map[chr] || '&amp;';
      });
    };

    return SelectParser;
  })();

  SelectParser.select_to_array = function (select) {
    let child; let parser; let _i; let _len; let _ref;
    parser = new SelectParser();
    _ref = select.childNodes;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      child = _ref[_i];
      parser.add_node(child);
    }
    return parser.parsed;
  };

  AbstractChosen = (function () {
    function AbstractChosen(_at_form_field, _at_options) {
      this.form_field = _at_form_field;
      this.options = _at_options != null ? _at_options : {};
      if (!AbstractChosen.browser_is_supported()) {
        return;
      }
      this.is_multiple = this.form_field.multiple;
      this.is_mice = $(this.form_field).data('mice');
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.on_ready();
    }

    AbstractChosen.prototype.set_default_values = function () {
      this.click_test_action = (function (_this) {
        return function (evt) {
          return _this.test_active_click(evt);
        };
      })(this);
      this.activate_action = (function (_this) {
        return function (evt) {
          return _this.activate_field(evt);
        };
      })(this);
      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === '' ? this.options.allow_single_deselect : false;
      this.disable_search_threshold = this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
      this.group_search = this.options.group_search != null ? this.options.group_search : true;
      this.search_contains = this.options.search_contains || false;
      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
      this.max_selected_options = this.options.max_selected_options || Infinity;
      this.inherit_select_classes = this.options.inherit_select_classes || false;
      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
      this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
      return this.prevent_dropdown_hide = false;
    };

    AbstractChosen.prototype.set_default_text = function () {
      if (this.form_field.getAttribute('data-placeholder')) {
        this.default_text = this.form_field.getAttribute('data-placeholder');
      } else if (this.is_multiple) {
        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
      } else {
        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
      }
      this.results_none_found = this.form_field.getAttribute('data-no-results-text') || this.options.no_results_text || AbstractChosen.default_no_result_text;
      this.show_more_hotels = this.form_field.getAttribute('data-show-more-hotels') || AbstractChosen.default_show_more_hotels;
      return this.link_more_hotels = this.form_field.getAttribute('data-link-more-hotels') || AbstractChosen.default_link_more_hotels;
    };

    AbstractChosen.prototype.choice_label = function (item) {
      if (this.include_group_label_in_selected && (item.group_label != null)) {
        return "<b class='group-name'>" + item.group_label + '</b>' + item.html;
      } else {
        return item.html;
      }
    };

    AbstractChosen.prototype.mouse_enter = function () {
      return this.mouse_on_container = true;
    };

    AbstractChosen.prototype.mouse_leave = function () {
      return this.mouse_on_container = false;
    };

    AbstractChosen.prototype.input_focus = function (evt) {
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout(((function (_this) {
            return function () {
              return _this.container_mousedown();
            };
          })(this)), 50);
        }
      } else if (!this.active_field) {
        return this.activate_field();
      }
    };

    AbstractChosen.prototype.input_blur = function (evt) {
      if (this.prevent_dropdown_hide) {
        return;
      }
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout(((function (_this) {
          return function () {
            return _this.blur_test();
          };
        })(this)), 100);
      }
    };

    AbstractChosen.prototype.results_option_build = function (options) {
      let content; let data; let data_content; let group_matched_content; let group_unmatched_content; let searchText; let shown_results; let _i; let _len; let _ref;
      content = '';
      group_unmatched_content = '';
      group_matched_content = '';
      shown_results = 0;
      searchText = this.get_search_text();
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        data = _ref[_i];
        data_content = '';
        if (data.group) {
          content += group_matched_content + group_unmatched_content;
          group_matched_content = '';
          group_unmatched_content = '';
          if (searchText.length !== 0 && data.classes !== 'last-searches') {
            data_content = this.result_add_group(data);
          } else if (searchText.length === 0) {
            data_content = this.result_add_group(data);
          }
        } else if (searchText.length !== 0 && data.classes !== 'last-search-opt') {
          data_content = this.result_add_option(data);
        } else if (searchText.length === 0) {
          data_content = this.result_add_option(data);
        }
        if (data_content !== '') {
          shown_results++;
          if (this.matchesSearch(data) || data.group) {
            group_matched_content += data_content;
          } else {
            group_unmatched_content += data_content;
          }
        }
        if (options != null ? options.first : void 0) {
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.single_set_selected_text(this.choice_label(data));
          }
        }
        if (shown_results >= this.max_shown_results) {
          break;
        }
      }
      return content + group_matched_content + group_unmatched_content;
    };

    AbstractChosen.prototype.matchesSearch = function (option) {
      let string; let target;
      if (!option.search_text) {
        return false;
      }
      string = option.search_text.toLowerCase();
      target = this.search_field.val().toLowerCase();
      return !!string.match(new RegExp(target));
    };

    AbstractChosen.prototype.build_option_dom = function (option) {
      let dates; let el; let text;
      el = document.createElement('div');
      el.className = 'option';
      text = document.createElement('span');
      text.className = 'value';
      text.innerHTML = option.search_text;
      el.appendChild(text);
      if (option.check_in && option.check_out) {
        dates = document.createElement('span');
        dates.className = 'saved-dates';
        dates.innerHTML = option.check_in + ' - ' + option.check_out;
        el.appendChild(dates);
      }
      return el;
    };

    AbstractChosen.prototype.result_add_option = function (option) {
      let classes; let highlight; let input; let match; let option_el; let regex; let result;
      if (!option.search_match) {
        return '';
      }
      if (!this.include_option_in_results(option)) {
        return '';
      }
      classes = [];
      if (!option.disabled && !(option.selected && this.is_multiple)) {
        classes.push('active-result');
      }
      if (option.disabled && !(option.selected && this.is_multiple)) {
        classes.push('disabled-result');
      }
      if (option.selected) {
        classes.push('result-selected');
      }
      if (option.group_array_index != null) {
        classes.push('group-option');
      }
      if (option.classes !== '') {
        classes.push(option.classes);
      }
      option_el = document.createElement('li');
      option_el.className = classes.join(' ');
      option_el.style.cssText = option.style;
      option_el.setAttribute('data-option-array-index', option.array_index);
      option_el.setAttribute('data-allow-children', option.allow_children);
      option_el.setAttribute('data-url', option.url);
      option_el.setAttribute('data-id', option.id);
      option_el.setAttribute('group-array-index', option.group_array_index);
      option_el.setAttribute('max-children-age', option.max_children_age);
      option_el.setAttribute('min-children-age', option.min_children_age);
      option_el.appendChild(this.build_option_dom(option));
      input = this.search_field.val();
      if (this.search_field.val().length > 0) {
        regex = new RegExp(input);
        match = input.match(regex)[0].toLowerCase();
        highlight = '<span class="high">' + match + '</span>';
        result = option.search_text.toLowerCase().replace(match, highlight);
        option_el.innerHTML = result;
      }
      if (option.title) {
        option_el.title = option.title;
      }
      return this.outerHTML(option_el);
    };

    AbstractChosen.prototype.result_add_group = function (group) {
      let classes; let group_el;
      if (!(group.search_match || group.group_match)) {
        return '';
      }
      if (!(group.active_options > 0)) {
        return '';
      }
      classes = [];
      classes.push('group-result');
      if (group.classes) {
        classes.push(group.classes);
      }
      group_el = document.createElement('li');
      group_el.className = classes.join(' ');
      group_el.setAttribute('group-array-index', group.array_index);
      group_el.innerHTML = group.search_text;
      if (group.title) {
        group_el.title = group.title;
      }
      return this.outerHTML(group_el);
    };

    AbstractChosen.prototype.results_update_field = function () {
      this.set_default_text();
      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }
      this.result_clear_highlight();
      this.results_build();
      if (this.results_showing) {
        return this.winnow_results();
      }
    };

    AbstractChosen.prototype.reset_single_select_options = function () {
      let result; let _i; let _len; let _ref; let _results;
      _ref = this.results_data;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        result = _ref[_i];
        if (result.selected) {
          _results.push(result.selected = false);
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    AbstractChosen.prototype.results_toggle = function () {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.results_search = function (evt) {
      if (this.results_showing) {
        return this.winnow_results();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.winnow_results = function () {
      if (this.resultsAreInitialized) return false;
      this.resultsAreInitialized = true;
      let contents; let hotels; let label; let option; let results; let results_group; let searchText; let _i; let _len; let _ref;
      this.no_results_clear();
      results = 0;
      searchText = this.get_search_text();
      hotels = ($(this.form_field)).find('.hotels');
      if (hotels.length) {
        if (searchText.length) {
          $(hotels).insertAfter(($(this.form_field)).find('.suggestions'));
        } else {
          $(hotels).insertAfter(($(this.form_field)).find('.destinations'));
        }
        this.results_data = SelectParser.select_to_array(this.form_field);
      }
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        option.search_match = false;
        results_group = null;
        if (this.include_option_in_results(option)) {
          if (option.group) {
            option.group_match = false;
            option.active_options = 0;
          }
          if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
            results_group = this.results_data[option.group_array_index];
            if (results_group.active_options === 0 && results_group.search_match) {
              results += 1;
            }
            results_group.active_options += 1;
          }
          option.search_text = option.group ? option.label : option.html;
          if (!(option.group && !this.group_search)) {
            if (option.translations) {
              option.search_match = option.translations.reduce(function (a, b) {
                let _ref1;
                if (typeof a === 'object') {
                  a = false;
                }
                a = (_ref1 = a === true) != null ? _ref1 : {
                  a: fuzzysearch(searchText, a.toLowerCase())
                };
                return a || fuzzysearch(searchText, b.toLowerCase());
              }, {});
            } else {
              option.search_match = fuzzysearch(searchText, option.search_text.toLowerCase());
            }
            if (option.search_match && !option.group) {
              results += 1;
            }
            if (option.search_match) {
              if (results_group != null) {
                results_group.group_match = true;
              }
            } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
              option.search_match = true;
            }
          }
        }
      }
      this.result_clear_highlight();
      if (results < 1 && searchText.length) {
        this.update_results_content('');
        return this.no_results(searchText);
      } else {
        label = '';
        if (this.form_field_jq.data('offer-label')) {
          label = "<li class='group-result in-offer'>" + this.form_field_jq.data('offer-label') + '</li>';
        }
        contents = label + this.results_option_build();
        this.update_results_content(contents);
        return this.winnow_results_set_highlight();
      }
    };

    AbstractChosen.prototype.choices_count = function () {
      let option; let _i; let _len; let _ref;
      if (this.selected_option_count != null) {
        return this.selected_option_count;
      }
      this.selected_option_count = 0;
      _ref = this.form_field.options;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        if (option.selected) {
          this.selected_option_count += 1;
        }
      }
      return this.selected_option_count;
    };

    AbstractChosen.prototype.choices_click = function (evt) {
      evt.preventDefault();
      if (!(this.results_showing || this.is_disabled)) {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.keyup_checker = function (evt) {
      let stroke; let _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      switch (stroke) {
      case 8:
        if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
          return this.keydown_backstroke();
        } else if (!this.pending_backstroke) {
          this.result_clear_highlight();
          return this.results_search();
        }
        break;
      case 13:
        evt.preventDefault();
        if (this.results_showing) {
          return this.result_select(evt);
        }
        break;
      case 27:
        if (this.results_showing) {
          this.results_hide();
        }
        return true;
      case 9:
      case 38:
      case 40:
      case 16:
      case 91:
      case 17:
      case 18:
        break;
      default:
        return this.results_search();
      }
    };

    AbstractChosen.prototype.clipboard_event_checker = function (evt) {
      return setTimeout(((function (_this) {
        return function () {
          return _this.results_search();
        };
      })(this)), 50);
    };

    AbstractChosen.prototype.container_width = function () {
      if (this.options.width != null) {
        return this.options.width;
      } else {
        return this.form_field.offsetWidth + 'px';
      }
    };

    AbstractChosen.prototype.include_option_in_results = function (option) {
      if (this.is_multiple && (!this.display_selected_options && option.selected)) {
        return false;
      }
      if (!this.display_disabled_options && option.disabled) {
        return false;
      }
      if (option.empty) {
        return false;
      }
      return true;
    };

    AbstractChosen.prototype.search_results_touchstart = function (evt) {
      this.touch_started = true;
      return this.search_results_mouseover(evt);
    };

    AbstractChosen.prototype.search_results_touchmove = function (evt) {
      this.touch_started = false;
      return this.search_results_mouseout(evt);
    };

    AbstractChosen.prototype.search_results_touchend = function (evt) {
      if (this.touch_started) {
        return this.search_results_mouseup(evt);
      }
    };

    AbstractChosen.prototype.outerHTML = function (element) {
      let tmp;
      if (element.outerHTML) {
        return element.outerHTML;
      }
      tmp = document.createElement('div');
      tmp.appendChild(element);
      return tmp.innerHTML;
    };

    AbstractChosen.browser_is_supported = function () {
      return true;
    };

    AbstractChosen.default_multiple_text = 'Select Some Options';

    AbstractChosen.default_single_text = 'Select an Option';

    AbstractChosen.default_no_result_text = 'No results match';

    AbstractChosen.default_show_more_hotels = 'Show more hotels';

    AbstractChosen.default_link_more_hotels = 'en/hotels';

    return AbstractChosen;
  })();

  $ = jQuery;

  $.fn.extend({
    chosen: function (options) {
      if (!AbstractChosen.browser_is_supported()) {
        return this;
      }
      return this.each(function (input_field) {
        let $this; let chosen;
        $this = $(this);
        chosen = $this.data('chosen');
        if (options === 'destroy') {
          if (chosen instanceof Chosen) {
            chosen.destroy();
          }
          return;
        }
        if (!(chosen instanceof Chosen)) {
          $this.data('chosen', new Chosen(this, options));
        }
      });
    }
  });

  Chosen = (function (_super) {
    __extends(Chosen, _super);

    function Chosen() {
      return Chosen.__super__.constructor.apply(this, arguments);
    }

    Chosen.prototype.setup = function () {
      this.form_field_jq = $(this.form_field);
      this.current_selectedIndex = this.form_field.selectedIndex;
      return this.is_rtl = this.form_field_jq.hasClass('chosen-rtl');
    };

    Chosen.prototype.set_up_html = function () {
      let btn_clear; let btn_confirm; let container_classes; let container_props; let placeholder;
      container_classes = ['chosen-container'];
      container_classes.push('chosen-container-' + (this.is_multiple ? 'multi' : 'single'));
      if (this.inherit_select_classes && this.form_field.className) {
        container_classes.push(this.form_field.className);
      }
      if (this.is_rtl) {
        container_classes.push('chosen-rtl');
      }
      container_props = {
        'class': container_classes.join(' '),
        'style': 'width: ' + (this.container_width()) + ';',
        'title': this.form_field.title
      };
      if (this.form_field.id.length) {
        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + '_chosen';
      }
      this.container = $('<div />', container_props);
      if (this.is_multiple) {
        this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>');
        if (this.is_mice) {
          placeholder = this.form_field_jq.data('placeholder');
          btn_confirm = this.form_field_jq.data('confirm-translation');
          btn_clear = this.form_field_jq.data('clear-translation');
          this.container.html('<input type="text" value="' + placeholder + '" class="default" autocomplete="off" style="width:25px;" /><p class="counter hidden"></p><div class="chosen-drop"><ul class="chosen-choices"><li class="search-field"></li></ul><ul class="chosen-results"></ul><div class="confirm-box"><a href="#" class="secondary-btn">' + btn_confirm + '</a><a href="#" class="clear-all">' + btn_clear + '</a></div>');
        }
      } else {
        this.container.html('<a class="chosen-single chosen-default"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><div class="alert alert-warning package-destination-hotel-not-included-warning negative m0 fullWidth hidden"></div><div class="my-iberostar-info"><h3 class="my-title t-fb-label"></h3><p class="my-info t-p"></p><a href="#" class="my-link fake-link" data-remote="true" data-ajax-lazy-img data-user-url></a></div><div class="familiar-hotels"><h3></h3><div class="fastbooking-adults"></div></div> <div class="select-place-to-go"></div><ul class="chosen-results"></ul></div>');
      }
      this.form_field_jq.hide().after(this.container);
      this.dropdown = this.container.find('div.chosen-drop').first();
      this.search_field = this.container.find('input').first();
      this.search_results = this.container.find('ul.chosen-results').first();
      this.search_field_scale();
      this.search_no_results = this.container.find('li.no-results').first();
      if (this.is_multiple) {
        this.search_choices = this.container.find('ul.chosen-choices').first();
        this.search_container = this.container.find('li.search-field').first();
      } else {
        this.search_container = this.container.find('div.chosen-search').first();
        this.selected_item = this.container.find('.chosen-single').first();
      }
      this.results_build();
      this.set_tab_index();
      return this.set_label_behavior();
    };

    Chosen.prototype.on_ready = function () {
      return this.form_field_jq.trigger('chosen:ready', {
        chosen: this
      });
    };

    Chosen.prototype.register_observers = function () {
      let clear_btn; let confirm_btn;
      this.container.bind('touchstart.chosen', (function (_this) {
        return function (evt) {
          return _this.container_mousedown(evt);
        };
      })(this));
      this.container.bind('touchend.chosen', (function (_this) {
        return function (evt) {
          _this.container_mouseup(evt);
        };
      })(this));
      this.container.bind('mousedown.chosen', (function (_this) {
        return function (evt) {
          _this.container_mousedown(evt);
        };
      })(this));
      this.container.bind('mouseup.chosen', (function (_this) {
        return function (evt) {
          _this.container_mouseup(evt);
        };
      })(this));
      this.container.bind('mouseenter.chosen', (function (_this) {
        return function (evt) {
          _this.mouse_enter(evt);
        };
      })(this));
      this.container.bind('mouseleave.chosen', (function (_this) {
        return function (evt) {
          _this.mouse_leave(evt);
        };
      })(this));
      this.search_results.bind('mouseup.chosen', (function (_this) {
        return function (evt) {
          _this.search_results_mouseup(evt);
        };
      })(this));
      this.search_results.bind('mouseover.chosen', (function (_this) {
        return function (evt) {
          _this.search_results_mouseover(evt);
        };
      })(this));
      this.search_results.bind('mouseout.chosen', (function (_this) {
        return function (evt) {
          _this.search_results_mouseout(evt);
        };
      })(this));
      this.search_results.bind('mousewheel.chosen DOMMouseScroll.chosen', (function (_this) {
        return function (evt) {
          _this.search_results_mousewheel(evt);
        };
      })(this));
      this.search_results.bind('touchstart.chosen', (function (_this) {
        return function (evt) {
          _this.search_results_touchstart(evt);
        };
      })(this));
      this.search_results.bind('touchmove.chosen', (function (_this) {
        return function (evt) {
          _this.search_results_touchmove(evt);
        };
      })(this));
      this.search_results.bind('.chosen', (function (_this) {
        return function (evt) {
          _this.search_results_touchend(evt);
        };
      })(this));
      this.search_results.bind('touchend.chosen', (function (_this) {
        return function (evt) {
          _this.search_results_touchend(evt);
        };
      })(this));
      this.form_field_jq.bind('chosen:updated.chosen', (function (_this) {
        return function (evt) {
          _this.results_update_field(evt);
        };
      })(this));
      this.form_field_jq.bind('chosen:activate.chosen', (function (_this) {
        return function (evt) {
          _this.activate_field(evt);
        };
      })(this));
      this.form_field_jq.bind('chosen:open.chosen', (function (_this) {
        return function (evt) {
          _this.container_mousedown(evt);
        };
      })(this));
      this.form_field_jq.bind('chosen:close.chosen', (function (_this) {
        return function (evt) {
          _this.input_blur(evt);
        };
      })(this));
      this.form_field_jq.bind('chosen:prevent_dropdown_hide', (function (_this) {
        return function (evt) {
          _this.prevent_dropdown_hide = true;
        };
      })(this));
      this.form_field_jq.bind('chosen:allow_dropdown_hide', (function (_this) {
        return function (evt) {
          _this.prevent_dropdown_hide = false;
        };
      })(this));
      this.search_field.bind('blur.chosen', (function (_this) {
        return function (evt) {
          _this.input_blur(evt);
        };
      })(this));
      this.search_field.bind('keyup.chosen', (function (_this) {
        return function (evt) {
          _this.keyup_checker(evt);
        };
      })(this));
      this.search_field.bind('keydown.chosen', (function (_this) {
        return function (evt) {
          _this.keydown_checker(evt);
        };
      })(this));
      this.search_field.bind('focus.chosen', (function (_this) {
        return function (evt) {
          _this.input_focus(evt);
        };
      })(this));
      this.search_field.bind('cut.chosen', (function (_this) {
        return function (evt) {
          _this.clipboard_event_checker(evt);
        };
      })(this));
      this.search_field.bind('paste.chosen', (function (_this) {
        return function (evt) {
          _this.clipboard_event_checker(evt);
        };
      })(this));
      if (this.is_multiple) {
        this.search_choices.bind('click.chosen', (function (_this) {
          return function (evt) {
            _this.choices_click(evt);
          };
        })(this));
        if (this.is_mice) {
          confirm_btn = this.container.find('.secondary-btn');
          confirm_btn.bind('click touchend', (function (_this) {
            return function (evt) {
              _this.hide_opened_chosen(evt);
            };
          })(this));
          clear_btn = this.container.find('.clear-all');
          return clear_btn.bind('click touchend', (function (_this) {
            return function (evt) {
              _this.clear_all_mice(evt);
            };
          })(this));
        }
      } else {
        return this.container.bind('click.chosen', function (evt) {
          evt.preventDefault();
        });
      }
    };

    Chosen.prototype.destroy = function () {
      $(this.container[0].ownerDocument).unbind('click.chosen', this.click_test_action);
      if (this.search_field[0].tabIndex) {
        this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
      }
      this.container.remove();
      this.form_field_jq.removeData('chosen');
      return this.form_field_jq.show();
    };

    Chosen.prototype.search_field_disabled = function () {
      this.is_disabled = this.form_field_jq[0].disabled;
      if (this.is_disabled) {
        this.container.addClass('chosen-disabled');
        this.search_field[0].disabled = true;
        if (!this.is_multiple) {
          this.selected_item.unbind('focus.chosen', this.activate_action);
        }
        return this.close_field();
      } else {
        this.container.removeClass('chosen-disabled');
        this.search_field[0].disabled = false;
        if (!this.is_multiple) {
          return this.selected_item.bind('focus.chosen', this.activate_action);
        }
      }
    };

    Chosen.prototype.container_mousedown = function (evt) {
      if (!this.is_disabled) {
        if (evt && ['mousedown', 'touchstart'].includes(evt.type) && !this.results_showing) {
          evt.preventDefault();
        }
        if (!((evt != null) && ($(evt.target)).hasClass('search-choice-close'))) {
          if (!this.active_field) {
            if (this.is_multiple) {
              this.search_field.val('');
            }
            $(this.container[0].ownerDocument).bind('click.chosen', this.click_test_action);
            this.results_show();
          } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents('a.chosen-single').length)) {
            evt.preventDefault();
            this.results_toggle();
          }
          return this.activate_field();
        }
      }
    };

    Chosen.prototype.container_mouseup = function (evt) {
      if (evt.target.nodeName === 'ABBR' && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };

    Chosen.prototype.search_results_mousewheel = function (evt) {
      let delta;
      if (evt.originalEvent) {
        delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
      }
      if (delta != null) {
        evt.preventDefault();
        if (evt.type === 'DOMMouseScroll') {
          delta = delta * 40;
        }
        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
      }
    };

    Chosen.prototype.blur_test = function (evt) {
      if (!this.active_field && this.container.hasClass('chosen-container-active')) {
        return this.close_field();
      }
    };

    Chosen.prototype.close_field = function () {
      $(this.container[0].ownerDocument).unbind('click.chosen', this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClass('chosen-container-active');
      this.clear_backstroke();
      this.show_search_field_default();
      return this.search_field_scale();
    };

    Chosen.prototype.activate_field = function () {
      this.container.addClass('chosen-container-active');
      this.active_field = true;
      this.search_field.val(this.search_field.val());
      return this.search_field.focus();
    };

    Chosen.prototype.test_active_click = function (evt) {
      let active_container;
      active_container = $(evt.target).closest('.chosen-container');
      if (active_container.length && this.container[0] === active_container[0]) {
        return this.active_field = true;
      } else {
        return this.close_field();
      }
    };

    Chosen.prototype.results_build = function () {
      this.parsing = true;
      this.selected_option_count = null;
      this.results_data = SelectParser.select_to_array(this.form_field);
      if (this.is_multiple) {
        this.search_choices.find('li.search-choice').remove();
      } else if (!this.is_multiple) {
        this.single_set_selected_text();
        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
          this.search_field[0].readOnly = true;
          this.container.addClass('chosen-container-single-nosearch');
        } else {
          this.search_field[0].readOnly = false;
          this.container.removeClass('chosen-container-single-nosearch');
        }
      }
      this.update_results_content(this.results_option_build({
        first: true
      }));
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      return this.parsing = false;
    };

    Chosen.prototype.result_do_highlight = function (el) {
      let high_bottom; let high_top; let maxHeight; let visible_bottom; let visible_top;
      if (el.length) {
        this.result_clear_highlight();
        this.result_highlight = el;
        this.result_highlight.addClass('highlighted');
        maxHeight = parseInt(this.search_results.css('maxHeight'), 10);
        visible_top = this.search_results.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
        high_bottom = high_top + this.result_highlight.outerHeight();
        if (high_bottom >= visible_bottom) {
          return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
        } else if (high_top < visible_top) {
          return this.search_results.scrollTop(high_top);
        }
      }
    };

    Chosen.prototype.result_clear_highlight = function () {
      if (this.result_highlight) {
        this.result_highlight.removeClass('highlighted');
      }
      return this.result_highlight = null;
    };

    Chosen.prototype.results_show = function () {
      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
        this.form_field_jq.trigger('chosen:maxselected', {
          chosen: this
        });
        return false;
      }
      this.container.addClass('chosen-with-drop');
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.val(this.search_field.val());
      this.winnow_results();
      return this.form_field_jq.trigger('chosen:showing_dropdown', {
        chosen: this
      });
    };

    Chosen.prototype.update_results_content = function (content) {
      return this.search_results.html(content);
    };

    Chosen.prototype.results_hide = function () {
      if (this.prevent_dropdown_hide) {
        return;
      }
      if (this.results_showing) {
        this.result_clear_highlight();
        this.container.removeClass('chosen-with-drop');
        this.form_field_jq.trigger('chosen:hiding_dropdown', {
          chosen: this
        });
      }
      return this.results_showing = false;
    };

    Chosen.prototype.set_tab_index = function (el) {
      let ti;
      if (this.form_field.tabIndex) {
        ti = this.form_field.tabIndex;
        this.form_field.tabIndex = -1;
        return this.search_field[0].tabIndex = ti;
      }
    };

    Chosen.prototype.set_label_behavior = function () {
      this.form_field_label = this.form_field_jq.parents('label');
      if (!this.form_field_label.length && this.form_field.id.length) {
        this.form_field_label = $("label[for='" + this.form_field.id + "']");
      }
      if (this.form_field_label.length > 0) {
        return this.form_field_label.bind('click.chosen', (function (_this) {
          return function (evt) {
            if (_this.is_multiple) {
              return _this.container_mousedown(evt);
            } else {
              return _this.activate_field();
            }
          };
        })(this));
      }
    };

    Chosen.prototype.show_search_field_default = function () {
      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
        this.search_field.val(this.default_text);
        return this.search_field.addClass('default');
      } else {
        this.search_field.val('');
        return this.search_field.removeClass('default');
      }
    };

    Chosen.prototype.search_results_mouseup = function (evt) {
      let target;
      target = $(evt.target).hasClass('active-result') ? $(evt.target) : $(evt.target).parents('.active-result').first();
      if (target.length) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };

    Chosen.prototype.search_results_mouseover = function (evt) {
      let target;
      target = $(evt.target).hasClass('active-result') ? $(evt.target) : $(evt.target).parents('.active-result').first();
      if (target) {
        return this.result_do_highlight(target);
      }
    };

    Chosen.prototype.search_results_mouseout = function (evt) {
      if ($(evt.target).hasClass('active-result' || $(evt.target).parents('.active-result').first())) {
        return this.result_clear_highlight();
      }
    };

    Chosen.prototype.choice_build = function (item) {
      let choice; let close_link;
      choice = $('<li />', {
        'class': 'search-choice'
      }).html('<span>' + (this.choice_label(item)) + '</span>');
      if (item.disabled) {
        choice.addClass('search-choice-disabled');
      } else {
        close_link = $('<a />', {
          'class':                   'search-choice-close',
          'data-option-array-index': item.array_index
        });
        close_link.bind('click.chosen touchend', (function (_this) {
          return function (evt) {
            let checkbox_opt;
            _this.choice_destroy_link_click(evt);
            if (_this.is_mice) {
              checkbox_opt = _this.form_field_jq.parent().find('li[data-option-array-index="' + item.array_index + '"]');
              return $(checkbox_opt).removeClass('result-selected').removeClass('hidden')
                .addClass('active-result');
            }
          };
        })(this));
        choice.append(close_link);
      }
      this.search_container.before(choice);
      if (this.is_mice) {
        return this.update_multiple_count();
      }
    };

    Chosen.prototype.choice_destroy_link_click = function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (!this.is_disabled) {
        this.choice_destroy($(evt.target));
      }
      if (this.is_mice) {
        return this.update_multiple_count();
      }
    };

    Chosen.prototype.update_multiple_count = function () {
      let count; let counter; let parent; let text; let translation;
      parent = this.form_field_jq.parent();
      counter = parent.find('.counter');
      translation = this.form_field_jq.data('item-translations');
      count = parent.find('.search-choice').length;
      text = '';
      if (count === 0) {
        parent.addClass('parsley-error');
        parent.next('.fz-error-container').removeClass('hidden');
        counter.addClass('hidden');
        return;
      } else {
        parent.removeClass('parsley-error');
        parent.next('.fz-error-container').addClass('hidden');
      }
      if (this.form_field_jq.hasClass('no-count') && count === 1) {
        text = parent.find('.search-choice span').text();
      } else {
        text = this.form_field_jq.hasClass('no-count') ? '' + translation : count + ' ' + translation;
      }
      counter.removeClass('hidden').text(text);
      return counter.trigger('selector_change');
    };

    Chosen.prototype.choice_destroy = function (link) {
      if (this.result_deselect(link[0].getAttribute('data-option-array-index'))) {
        this.show_search_field_default();
        if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
          this.results_hide();
        }
        link.parents('li').first().remove();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.results_reset = function () {
      this.reset_single_select_options();
      this.form_field.options[0].selected = true;
      this.single_set_selected_text();
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.form_field_jq.trigger('change');
      if (this.active_field) {
        return this.results_hide();
      }
    };

    Chosen.prototype.results_reset_cleanup = function () {
      this.current_selectedIndex = this.form_field.selectedIndex;
      return this.selected_item.find('abbr').remove();
    };

    Chosen.prototype.result_select = function (evt) {
      let high; let item;
      if (this.result_highlight) {
        high = this.result_highlight;
        this.result_clear_highlight();
        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
          this.form_field_jq.trigger('chosen:maxselected', {
            chosen: this
          });
          return false;
        }
        if (this.is_multiple) {
          high.removeClass('active-result');
        } else {
          this.reset_single_select_options();
        }
        high.addClass('result-selected');
        if (this.is_mice) {
          high.addClass('hidden');
        }
        item = this.results_data[high[0].getAttribute('data-option-array-index')];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        this.selected_option_count = null;
        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.single_set_selected_text(this.choice_label(item));
        }
        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
          this.form_field_jq.trigger('chosen:change_before_hide', {
            'selected': this.form_field.options[item.options_index].value
          });
        }
        if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
          this.results_hide();
        }
        this.show_search_field_default();
        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
          this.form_field_jq.trigger('change', {
            'selected': this.form_field.options[item.options_index].value
          });
        }
        this.current_selectedIndex = this.form_field.selectedIndex;
        evt.preventDefault();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.single_set_selected_text = function (text) {
      if (text == null) {
        text = this.default_text;
      }
      if (text === this.default_text) {
        this.selected_item.addClass('chosen-default');
      } else {
        this.single_deselect_control_build();
        this.selected_item.removeClass('chosen-default');
      }
      return this.selected_item.find('span').html(text);
    };

    Chosen.prototype.result_deselect = function (pos) {
      let result_data;
      result_data = this.results_data[pos];
      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        this.selected_option_count = null;
        this.result_clear_highlight();
        if (this.results_showing) {
          this.winnow_results();
        }
        this.form_field_jq.trigger('change', {
          deselected: this.form_field.options[result_data.options_index].value
        });
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };

    Chosen.prototype.single_deselect_control_build = function () {
      if (!this.allow_single_deselect) {
        return;
      }
      if (!this.selected_item.find('abbr').length) {
        this.selected_item.find('span').first().after('<abbr class="search-choice-close"></abbr>');
      }
      return this.selected_item.addClass('chosen-single-with-deselect');
    };

    Chosen.prototype.get_search_text = function () {
      return $('<div/>').text($.trim(this.search_field.val())).html();
    };

    Chosen.prototype.winnow_results_set_highlight = function () {
      let do_high; let selected_results;
      selected_results = !this.is_multiple ? this.search_results.find('.result-selected.active-result') : [];
      do_high = selected_results.length ? selected_results.first() : this.search_results.find('.active-result').first();
      if (do_high != null) {
        return this.result_do_highlight(do_high);
      }
    };

    Chosen.prototype.no_results = function (terms) {
      let no_results_html;
      no_results_html = $('<li class="no-results alert alert-warning">' + this.results_none_found + ' "<span></span><button class="close-no-results" type="button"></button>"</li>');
      no_results_html.find('span').first().html(terms);
      this.search_results.append(no_results_html);
      return this.form_field_jq.trigger('chosen:no_results', {
        chosen: this
      });
    };

    Chosen.prototype.no_results_clear = function () {
      return this.search_results.find('.no-results').remove();
    };

    Chosen.prototype.keydown_arrow = function () {
      let next_sib;
      if (this.results_showing && this.result_highlight) {
        next_sib = this.result_highlight.nextAll('li.active-result').first();
        if (next_sib) {
          return this.result_do_highlight(next_sib);
        }
      } else {
        return this.results_show();
      }
    };

    Chosen.prototype.keyup_arrow = function () {
      let prev_sibs;
      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        prev_sibs = this.result_highlight.prevAll('li.active-result');
        if (prev_sibs.length) {
          return this.result_do_highlight(prev_sibs.first());
        } else {
          if (this.choices_count() > 0) {
            this.results_hide();
          }
          return this.result_clear_highlight();
        }
      }
    };

    Chosen.prototype.keydown_backstroke = function () {
      let next_available_destroy;
      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.find('a').first());
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container.siblings('li.search-choice').last();
        if (next_available_destroy.length && !next_available_destroy.hasClass('search-choice-disabled')) {
          this.pending_backstroke = next_available_destroy;
          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClass('search-choice-focus');
          }
        }
      }
    };

    Chosen.prototype.clear_backstroke = function () {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClass('search-choice-focus');
      }
      return this.pending_backstroke = null;
    };

    Chosen.prototype.keydown_checker = function (evt) {
      let stroke; let _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }
      switch (stroke) {
      case 8:
        this.backstroke_length = this.search_field.val().length;
        break;
      case 9:
        if (this.results_showing && !this.is_multiple) {
          this.result_select(evt);
        }
        this.mouse_on_container = false;
        break;
      case 13:
        if (this.results_showing) {
          evt.preventDefault();
        }
        break;
      case 32:
        if (this.disable_search) {
          evt.preventDefault();
        }
        break;
      case 38:
        evt.preventDefault();
        this.keyup_arrow();
        break;
      case 40:
        evt.preventDefault();
        this.keydown_arrow();
        break;
      }
    };

    Chosen.prototype.search_field_scale = function () {
      let div; let f_width; let h; let style; let style_block; let styles; let w; let _i; let _len;
      if (this.is_multiple) {
        h = 0;
        w = 0;
        style_block = 'position:absolute; left: -1000px; top: -1000px; display:none;';
        styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
        for (_i = 0, _len = styles.length; _i < _len; _i++) {
          style = styles[_i];
          style_block += style + ':' + this.search_field.css(style) + ';';
        }
        div = $('<div />', {
          'style': style_block
        });
        div.text(this.search_field.val());
        $('body').append(div);
        w = div.width() + 25;
        div.remove();
        f_width = this.container.outerWidth();
        if (w > f_width - 10) {
          w = f_width - 10;
        }
        return this.search_field.css({
          'width': w + 'px'
        });
      }
    };

    Chosen.prototype.hide_opened_chosen = function (evt) {
      evt.preventDefault();
      return this.close_field();
    };

    Chosen.prototype.clear_all_mice = function (evt) {
      evt.preventDefault();
      return this.container.find('.search-choice-close').each(function () {
        return $(this).trigger('click.chosen');
      });
    };

    return Chosen;
  })(AbstractChosen);
}).call(this);
